<template>
  <div>
    <div
      class="bg-white p-3 rounded my-2"
      v-for="(register, index) in lista"
      :key="index"
    >
      <div class="row">
        <div class="col-md-2">
          <div class="label">Plano</div>
          <div class="value">{{ register.descricao }}</div>
        </div>
        <div class="col-md-2">
          <div class="label">Quantidade CNPJ</div>
          <div class="value">
            {{ register.qtdCnpj }}
          </div>
        </div>
        <div class="col-md-5">
          <div class="label">Operadoras</div>
          <div class="value">{{ register.operadoras }}</div>
        </div>
        <div class="col-md-2">
          <div class="label">Status</div>
          <div class="value">{{ register.status }}</div>
        </div>
        <div
          class="col-md-1 mt-1"
          v-if="register.pagamento && register.exibirBotao"
        >
          <button class="btn btn-success" @click="abrirPagamento()">
            Pagar
          </button>
        </div>
        <div class="col-md-1 mt-1" v-else-if="register.exibirBotao">
          <button class="btn btn-success disabled">Pagar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Lista",
  props: {
    lista: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      anuncioId: null,
      desc: null,
      loading: false,
    };
  },
  filters: {
    formataCPF(cpf) {
      //retira os caracteres indesejados...
      cpf = cpf.replace(/[^\d]/g, "");

      //realizar a formatação...
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formataData(dataObj) {
      const data = new Date(dataObj);
      const dataStr =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
      return dataStr;
    },
  },
  methods: {
    abrirPagamento() {
      this.$router.push({ name: "pagamento-conciliador" });
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.simple-value {
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
